import axios from "axios";
import routes from "../app/routes";

export const managerPolicyActions = {
  loadPolicy: (dispatch, enterpriseId, afterCallback = () => {}) => {
    axios.get(routes.api.enterprises.policy(enterpriseId)).then((resp) => {
      dispatch({ type: "loadPolicy", policy: resp.data.data });
      afterCallback();
    });
  },
};
